<template>
    <div class="ques-edit-old">
        <section class="ques-detail">
            <div class="title">问答内容</div>
            <veui-input
                v-model="formData.title"
                class="ques-input"
                placeholder="请在此处输入问题，在下方填写回答内容"
            />
            <div class="answer-content">
                <div class="ques-editor-box">
                    <customize-editor
                        ref="editorItem"
                        :quill-id="0"
                        :quill-toolbar="quillToolbar"
                        external-class="ques-editor"
                        quill-placeholder=" "
                        :is-default-upload="false"
                        @editor-change="editorChange"
                    />
                    <div class="editor-text-tip">
                        <span
                            :class="{'error': formData.answer && formData.answer.length > maxNum}"
                        >{{ formData.answer && formData.answer.length || 0 }}</span> / {{ maxNum }}
                    </div>
                </div>
                <div class="answer-exp">
                    <div class="exp-title">回答范例({{ curPage + 1 }}/{{ quesList.length }})</div>
                    <div class="question">{{ quesList[curPage] && quesList[curPage].question || '' }}</div>
                    <!--bca-disable-->
                    <div class="answer" v-html="quesList[curPage] && quesList[curPage].answer || ''"></div>
                    <div class="btns">
                        <veui-button
                            ui="text"
                            :disabled="curPage === 0"
                            @click="changeQues('last')"
                        >上一个</veui-button>
                        <veui-button
                            ui="text"
                            :disabled="curPage === quesList.length - 1"
                            @click="changeQues('next')"
                        >下一个</veui-button>
                    </div>
                </div>
            </div>
        </section>
        <section class="ques-submit">
            <veui-button class="btn" @click="handleSubmit">上传</veui-button>
            <veui-button class="btn cancel" @click="goBack">取消</veui-button>
        </section>
    </div>
</template>

<script>
// 案例新增页
import {Input, Button} from 'veui';
import CustomizeEditor from '@/components/customize-editor';
import {quesExps} from '../data';
export default {
    name: '',
    components: {
        'veui-button': Button,
        'veui-input': Input,
        CustomizeEditor
    },
    data() {
        return {
            quesList: quesExps,
            formData: {},
            quillToolbar: [
                ['bold', 'italic', 'underline'],
                [{header: 1}, {header: 2}, 'blockquote'],
                [{list: 'ordered'}, {list: 'bullet'}],
                [{indent: '-1'}, {indent: '+1'}, {direction: 'rtl'}, {align: []}],
                ['link', 'image']
            ],
            // 提交锁
            isSubmit: false,
            // 最大字数限制
            maxNum: 6000,
            showSubmitSucc: false,
            curPage: 0,
            isAdd: false // 是否点击新建一个
        };
    },
    props: {
        qaInfo: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        qaInfo: {
            deep: true,
            immediate: true,
            handler(val) {
                if (Object.keys(val).length > 0) {
                    this.formData = {
                        answer: val.reply_content,
                        title: val.title
                    };
                    // 富文本编辑器内容赋值
                    this.setContent(val.reply_content);
                }
            }
        }
    },
    methods: {
        // 提交
        handleSubmit() {
            const {title, answer} = this.formData || {};
            if (!title || !answer) {
                let toast = {
                    content: '请正确填写问题以及回答内容后再提交',
                    duration: 1
                };
                this.$Message.error(toast);
                return;
            }
            if (answer.length > this.maxNum) {
                let toast = {
                    content: '已超出字数限制',
                    duration: 1
                };
                this.$Message.error(toast);
                return;
            }
            this.submitQueston();
        },
        goBack() {
            this.$emit('hideQuesEdit');
        },
        /**
         * 富文本编辑器-输入
         * @param {object} 文本内容
         */

        editorChange(args = {}) {
            let {innerHTML = ''} = args;
            this.$set(this.formData, 'answer', innerHTML);
        },

        /**
         * 点击再传一个
         */

        uploadMore() {
            this.showSubmitSucc = false;
            this.isAdd = true;
            // 清空表单
            this.formData.title = '';
            this.formData.answer = '';
        },

        /**
         * 跳转列表页
         */

        toQuesList() {
            this.$emit('toQuesList');
        },
        changeQues(type) {
            if (type === 'last' && this.curPage > 0) {
                this.curPage = this.curPage - 1;
            }
            if (type === 'next' && this.curPage < this.quesList.length - 1) {
                this.curPage = this.curPage + 1;
            }
            if (document.getElementsByClassName('answer')[0]) {
                document.getElementsByClassName('answer')[0].scrollTop = 0;
            }
        },
        /**
         * 设置editor内容
         * @param {string} content 内容
         */

        setContent(content) {
            this.$nextTick(() => {
                this.$refs.editorItem && this.$refs.editorItem.setContent(content);
            });
        },

        /**
         * 提交回答
         * @param {String} content 输入的回答
         */

        submitQueston() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            const {packId, title, answer} = this.formData;
            let id = this.qaInfo.id;
            const data = {
                content: answer,
                ...(packId && {
                    pack_id: packId
                }),
                type: 'submit',
                ...(id && !this.isAdd && {
                    content_id: id,
                    type: 'edit'
                }),
                origin: 'knowledge',
                title
            };
            this.$http({
                method: 'post',
                url: '/bp/api/content/save',
                data
            }).then(res => {
                this.isSubmit = false;
                if (res && +res.code === 0) {
                    this.$toast.success(
                        '内容已成功提交，审核通过后即可自动发布，审核结果将在2小时内产出'
                    );
                    this.showSubmitSucc = true;
                    this.$emit('submitSuccess');
                    return;
                }
                this.$toast.error((res && res.msg) || '内容提交失败');
            }).catch(() => {
                this.isSubmit = false;
                this.$toast.error('内容提交失败');
            });
        }
    }
};
</script>

<style lang='less' scoped>
.ques-edit-old {
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgb(249, 250, 253);

    .header {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        padding: 24px 24px 25px;
        background: #fff;

        .go-back {
            position: relative;
            padding-left: 20px;
            cursor: pointer;

            &::before {
                height: 16px;
                width: 16px;
                position: absolute;
                content: "";
                left: 0;
                top: -1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/left.png") no-repeat center / 100% 100%;
            }
        }

        .line {
            padding: 0 10px;
        }
    }

    .ques-detail {
        padding: 24px;
        background: #fff;
        border-radius: 0 0 8px 8px;
        overflow-y: scroll;
        flex: 1;
        display: flex;
        flex-direction: column;

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            text-align: left;
        }

        .ques-input {
            border: none;
            margin-top: 20px;
            margin-bottom: 24px;
            width: 1068px;
            height: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 28px;
            line-height: 28px;
            text-align: left;
            padding: 0;

            /deep/.veui-input-placeholder {
                color: #b7b9c1;
            }

            &.veui-focus {
                box-shadow: none;
            }
        }

        .answer-content {
            display: flex;
            justify-content: space-between;
            flex: 1;
            overflow: hidden;

            .answer-exp {
                width: 310px;
                padding: 16px 0;
                background: #fff;
                border-radius: 1px;
                border: 1px solid #d1d1d1;
                position: relative;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                .exp-title {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1e1f24;
                    line-height: 16px;
                    text-align: left;
                    padding: 0 20px 15px;
                    border-bottom: 1px solid #edeef0;
                }

                .question {
                    margin-top: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1e1f24;
                    line-height: 24px;
                    text-align: justify;
                    padding: 0 20px;
                }

                .answer {
                    margin-top: 13px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1e1f24;
                    line-height: 20px;
                    text-align: justify;
                    flex: 1;
                    overflow: scroll;
                    padding: 0 20px 34px;
                }

                .btns {
                    height: 50px;
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    left: 0;
                    padding: 0 40px;
                    background: #fff;

                    .veui-button {
                        color: #05f;

                        &.veui-disabled {
                            color: rgba(73, 86, 107, .8);
                        }
                    }
                }
            }

            /deep/.ql-editor.ql-blank::before {
                font-family: PingFang SC;
                font-style: normal;
                font-size: 14px;
                color: #1e1f24;
                line-height: 20px;
            }
        }

        .foot-button {
            display: flex;
            justify-content: center;
            text-align: center;
            align-items: center;

            .btn {
                height: 36px;
                line-height: 36px;
                padding: 0 29px;
                border: 1px solid rgba(56, 85, 213, 1);
                border-radius: 4px;
                color: #3855d5;
                background: #fff;
                cursor: pointer;
            }

            .add-btn {
                background: #3855d5;
                color: #fff;
                margin-left: 12px;
            }
        }

        /deep/.veui-select.veui-select-expanded
        .veui-input {
            border: 1px solid #0052cc;
            box-shadow: 0 0 0 2px rgba(0, 102, 255, 20%);
        }

        .ques-editor-box {
            width: 747px;
            height: 100%;
            position: relative;

            .editor-text-tip {
                position: absolute;
                right: 20px;
                bottom: 10px;

                .error {
                    color: #f5222d;
                }
            }

            /deep/ .ql-editor {
                p img {
                    width: 40%;
                    height: 40%;
                }
            }
        }

        /deep/ .ques-editor {
            width: 100%;
            height: 100%;

            .quill-editor {
                height: 100%;
            }

            .ql-container {
                padding: 0 0 30px;
                width: 100%;
                height: calc(100% - 42px);
                border-color: #d3d9e6;
            }

            .ql-toolbar {
                border-color: #d3d9e6;
            }
        }
    }

    .ques-submit {
        margin-top: 24px;
        background: #fff;
        height: 92px;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;

        .btn {
            width: 160px;
            height: 44px;
            background: #05f;
            border-radius: 6px;
            margin: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
            line-height: 22px;
            text-align: center;
        }

        .cancel {
            background: #fff;
            color: #05f;
            margin-left: 0;
            border: 1px solid #05f;
        }
    }

    .submit-succ {
        background: #fff;
        height: 400px;
        border-radius: 0 0 8px 8px;
        text-align: center;
        padding-top: 93px;

        .icon {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            margin: 0 auto;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/upload-succ.png") no-repeat center / 100% 100%;
        }

        .content {
            margin-top: 18px;
            text-align: center;
            height: 18px;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
        }

        .btns {
            margin-top: 30px;

            .veui-button {
                width: 115px;
                height: 40px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #05f;
                color: #05f;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 16px;
            }

            .detail {
                background: #05f;
                border: none;
                color: #fff;
                margin-right: 20px;
            }
        }
    }
}
</style>